import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

const AuthIdentityDone = lazy(() => import('@/pages/auth/AuthIdentityDone'));

const authRoutes: RouteObject[] = [
  {
    path: '/auth',
    children: [
      {
        index: true,
        element: <AuthIdentityDone />
      },
      {
        path: 'identity/done',
        element: <AuthIdentityDone />
      }
    ]
  }
];

export default authRoutes;
